import React, { memo } from 'react';
import { Button, Text, ThemedImage, Callout } from 'core/components';
import kentikAiUser from 'app/assets/kentik-ai-user.svg';
import kentikAiUserDark from 'app/assets/kentik-ai-user-dark.svg';
import { inject } from 'mobx-react';
import { MessageItem, AgentMessageBubble, MessageHeader, Timestamp } from '../KaizenChatSession.styles';
import StepComponent from './StepComponent';

const stepSorter = (a, b) => (a.step_number || 0) - (b.step_number || 0);

// Memoized agent message component
const AgentMessage = memo(
  ({
    turn,
    stepReasoningOpenState,
    onToggleReasoning,
    onSelectToolResult,
    onSendToExplorer,
    onShowAgentDataInSidebar,
    formatDate,
    isCopilotMode,
    sessionModel,
    isExistingChatLoading,
    $auth
  }) => {
    const sortedSteps = turn.steps?.slice().sort(stepSorter);

    return (
      <MessageItem key={`agent-${turn.id}`}>
        <AgentMessageBubble>
          <MessageHeader>
            <ThemedImage src={kentikAiUser} darkSrc={kentikAiUserDark} width={24} height={24} />
            <Text fontSize={13} fontWeight="bold">
              Kentik AI
            </Text>
            <Timestamp muted fontSize={13} fontWeight="normal">
              {formatDate(turn.created_at)}
            </Timestamp>

            {$auth.isSudoer && (
              <Button
                small
                minimal
                icon="info-sign"
                onClick={() => onShowAgentDataInSidebar(turn, sortedSteps)}
                text="Show Data in Console"
              />
            )}
          </MessageHeader>

          {sortedSteps?.map((step, stepIndex) => {
            const stepId = step.id || stepIndex;
            const isStepReasoningOpen = stepReasoningOpenState[stepId] ?? true;

            return (
              <StepComponent
                key={`step-${stepId}`}
                $auth={$auth}
                turn={turn}
                step={step}
                stepIndex={stepIndex}
                isStepReasoningOpen={isStepReasoningOpen}
                onToggleReasoning={onToggleReasoning}
                onSelectToolResult={onSelectToolResult}
                onSendToExplorer={onSendToExplorer}
                isCopilotMode={isCopilotMode}
                isExistingChatLoading={isExistingChatLoading}
                sessionModel={sessionModel}
              />
            );
          })}

          {turn.error_message && (
            <Callout intent="danger">
              <Text small>Error: something went wrong</Text>
            </Callout>
          )}
        </AgentMessageBubble>
      </MessageItem>
    );
  }
);

AgentMessage.displayName = 'AgentMessage';

export default inject('$auth')(AgentMessage);
